/** @jsxImportSource @emotion/react */
"use client";

import { useModal } from "@ebay/nice-modal-react";
import type { MouseEventHandler } from "react";
import { forwardRef } from "react";

import type { HallowElement } from "../../../../types/hallowElement.types";
import type { HallowElementProps } from "../../../../types/hallowElementProps.types";
import type { ShareModalProps } from "../../../_base/modals/ShareModal/ShareModal.emotion";
import { ShareModal } from "../../../_base/modals/ShareModal/ShareModal.emotion";

const Element: HallowElement = "button";

export type ShareCampaignButtonProps = HallowElementProps<typeof Element> & {
  shareOptions: ShareModalProps;
};

export const ShareCampaignButton = forwardRef<any, ShareCampaignButtonProps>(
  ({ shareOptions, onClick, children, ...props }, ref) => {
    const shareModal = useModal(ShareModal);

    const handleClick: MouseEventHandler<HTMLButtonElement> = (event) => {
      if (onClick) onClick(event);
      shareModal.show(shareOptions);
    };

    return (
      <button onClick={handleClick} ref={ref} {...props}>
        {children}
      </button>
    );
  },
);

ShareCampaignButton.displayName = "ShareCampaignButton";
